"use strict";Object.defineProperty(exports, "__esModule", {value: true}); const makeChangeEvent = (value) => ({
  target: { value },
}); exports.makeChangeEvent = makeChangeEvent
